import { render, staticRenderFns } from "./LongNoteComponent.vue?vue&type=template&id=25f5e016&scoped=true&"
import script from "./LongNoteComponent.vue?vue&type=script&lang=js&"
export * from "./LongNoteComponent.vue?vue&type=script&lang=js&"
import style0 from "./LongNoteComponent.vue?vue&type=style&index=0&id=25f5e016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5e016",
  null
  
)

export default component.exports